module.exports = __webpack_public_path__ + "static/media/logo-colored.6bc5d626.png";